var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 32,
    viewBox: "0 0 101 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3964 25.3409H6.13208V0.394287H0V31.0574H22.3964V25.3409Z",
    fill: "#3843D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2072 9.83414H38.4927V21.508C38.4927 24.9029 36.6026 26.2827 34.1409 26.2827C31.6573 26.2827 29.7891 24.9029 29.7891 21.508V9.83414H24.0527V22.0118C24.0527 28.7139 28.8001 31.6049 34.1409 31.6049C39.4598 31.6049 44.2072 28.7139 44.2072 22.0118V9.83414Z",
    fill: "#3843D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1902 9.26469C51.3987 9.26469 46.8491 14.0175 46.8491 20.4348C46.8491 26.8741 51.3987 31.6049 58.1902 31.6049C61.7507 31.6049 64.7398 30.1813 66.7399 27.6187L62.6519 24.1363C61.443 25.4504 59.8605 26.2827 58.0143 26.2827C55.0472 26.2827 52.6955 23.983 52.6955 20.4348C52.6955 16.9086 55.0692 14.5869 58.0363 14.5869C59.9045 14.5869 61.2892 15.3316 62.5859 16.7114L66.7179 13.2728C64.7618 10.7102 61.7507 9.26469 58.1902 9.26469Z",
    fill: "#3843D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.393 9.83414H83.7884V12.1777C82.3818 10.4474 80.3378 9.26469 77.4146 9.26469C71.5462 9.26469 67.1065 14.0613 67.1065 20.4348C67.1065 26.8084 71.5462 31.6049 77.4146 31.6049C80.3378 31.6049 82.4038 30.4222 83.7884 28.7139V31.0574H89.393V9.83414ZM78.4696 14.5869C81.7444 14.5869 83.9643 17.0838 83.9643 20.4348C83.9643 23.7859 81.7444 26.2827 78.4696 26.2827C75.1068 26.2827 72.9749 23.6763 72.9749 20.4348C72.9749 17.1933 75.1068 14.5869 78.4696 14.5869Z",
    fill: "#3843D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6227 23.1069C94.3369 23.1069 92.3368 25.0562 92.3368 27.3341C92.3368 29.6338 94.3369 31.605 96.6227 31.605C98.8865 31.605 100.865 29.6338 100.865 27.3341C100.865 25.0562 98.8865 23.1069 96.6227 23.1069Z",
    fill: "#FF8283"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo_blue.169f341a83455ec73ede123f566cbf00.svg";
export { ForwardRef as ReactComponent };